/* eslint-disable no-nested-ternary */
import React, { useContext, useState } from 'react';

import { Button, Typography, ModalConfirmation } from 'design_system/src';
import { Grid } from '@mui/material';
import 'moment/locale/es';

import '../../ozoner.scss';
import { ReactComponent as Info } from 'design_system/src/static/icons/info.svg';
import { ReactComponent as Moto } from 'design_system/src/static/icons/motorcycle.svg';

import { toasterOptions } from 'models/shared/enums/toaster.enum';
import { updateLoan } from 'models/loan/controllers/loan.controller';
import { LoanStatus } from 'models/loan/enums/loan.enum';
import { toasterNotification } from 'models/shared/helpers/toasterNotification';
import { commonErrorHandler } from 'models/shared/helpers/errors';
import { momentLocal } from 'models/shared/helpers/dates';
import {
	RepossessionEvidenceTypeValues,
	RepossessionStatus,
} from 'models/repossession/enums/repossession.enums';
import { VehicleStatus } from 'models/inventory/enums/vehicle.enum';
import { editVehicle } from 'models/inventory/controllers/vehicle.controller';
import { ozonerContext } from '../OzonerContext';

function RepossessionOzoner() {
	const [openEnded, setOpenEnded] = useState(false);
	const [loadingEnded, setLoadingEnded] = useState(false);

	const { ozoner, financialForm, initializeContext, setTab } =
		useContext(ozonerContext);

	const RecoverVehicle = async () => {
		if (!financialForm.loan?._id) return;
		setLoadingEnded(true);
		updateLoan(financialForm.loan._id, {
			status: LoanStatus.repossession,
		})
			.then((newLoan) => {
				initializeContext();

				toasterNotification({
					msg: 'Se marco como recuperado el vehiculo',
					toasterType: toasterOptions.success,
					style: 'light',
				});
				setLoadingEnded(false);
				setOpenEnded(false);
			})
			.catch((error) => {
				commonErrorHandler(error);
				setLoadingEnded(false);
			});
	};

	const restoreLoan = async () => {
		if (!financialForm.vehicle?._id) return;
		editVehicle(
			{
				status: VehicleStatus.DELIVERED,
			},
			financialForm.vehicle.internalId,
		)
			.then(() => {
				toasterNotification({
					msg: 'Se restauro el credito',
					toasterType: toasterOptions.success,
					style: 'light',
				});
				initializeContext();
				setTab(4);
			})
			.catch((error) => {
				commonErrorHandler(error);
			});
	};

	return (
		<>
			{ozoner &&
			financialForm?.loan &&
			financialForm?.repossession &&
			financialForm.repossession?.recoveredPhotos ? (
				<Grid
					container
					direction="row"
					spacing={3}
					className="h_100_per p_t_md"
				>
					<Grid item xs={3}>
						<div className="bg_neutral_0 border_neutral_400 border_solid border_1 br_sm">
							<div
								id="base-loan"
								className="p_md border_b_solid border_1 border_neutral_400 "
							>
								<Typography
									scale="medium"
									weight="400"
									className="m_b_xs"
									textColor="neutral_800"
								>
									Fecha de recuperación
								</Typography>
								<Typography
									scale="medium"
									weight="600"
									className="m_b_md"
									textColor="neutral_800"
								>
									{momentLocal(
										financialForm?.repossession?.statusHistoric.find(
											(repo) => repo.status === RepossessionStatus.completed,
										)?.updatedAt,
									).format('DD/MM/yyyy')}
								</Typography>
								<Typography
									scale="medium"
									weight="400"
									className="m_b_xs"
									textColor="neutral_800"
								>
									Kilometraje Final
								</Typography>
								<Typography
									scale="medium"
									weight="600"
									className="m_b_md"
									textColor="neutral_800"
								>
									{financialForm?.repossession?.finalMileage ?? 'No Disponible'}
								</Typography>
							</div>
							{financialForm.vehicle?.status === VehicleStatus.ON_HOLD && (
								<div
									id="retained-loan"
									className="p_md border_b_solid border_1 border_neutral_400 "
								>
									<div className="flex_center flex_gap_md bg_red_100 text_red_300 br_xs p_y_xs w_100_per m_b_md">
										<Info className="dim_lg" />
										<Typography scale="small" weight="600" className="">
											Vehículo en Retencion
										</Typography>
									</div>
									<Button
										scale="small"
										className="w_100_per m_b_md"
										color="red"
										onClick={() => setOpenEnded(true)}
									>
										Recuperar Vehículo
									</Button>
									<Button
										scale="small"
										className="w_100_per"
										color="light_grey"
										onClick={() => restoreLoan()}
									>
										Restaurar credito
									</Button>
								</div>
							)}
						</div>
					</Grid>

					<Grid item xs={9}>
						<Grid container direction="row" spacing={3} className="m_b_md">
							{Object.entries(RepossessionEvidenceTypeValues).map(
								([key, title]) => (
									<Grid item xs={4} key={key}>
										<div className="br_xxs bg_neutral_0 flex_align_center p_x_md p_y_xs dim_100_per display_flex flex_col flex_gap_md border_1 border_neutral_400 border_solid ">
											<Typography scale="xsmall" weight="600">
												{title}
											</Typography>
											<div className="h_vp_20 ">
												<img
													src={
														financialForm.repossession?.recoveredPhotos?.find(
															(doc) => doc.typeEvidence === key,
														)?.url
													}
													alt={title}
													className="img_cover"
												/>
											</div>
										</div>
									</Grid>
								),
							)}
						</Grid>
					</Grid>
				</Grid>
			) : null}
			<ModalConfirmation
				openConfirmation={openEnded}
				handleClose={() => {
					setOpenEnded(false);
				}}
				icon={<Moto />}
				isConfirmationLoading={false}
				widthDesktop={40}
				actions={[
					{
						label: 'No recuperar',
						color: 'grey',
						action: () => {
							setOpenEnded(false);
						},
					},
					{
						label: 'Recuperar Vehículo',
						color: 'red',
						action: () => {
							RecoverVehicle();
						},
						loading: loadingEnded,
					},
				]}
				title={
					<Typography scale="large" weight="400">
						¿Estás seguro de que{' '}
						<Typography scale="large" weight="600" component="span">
							deseas marcar como recuperado este vehiculo?
						</Typography>
					</Typography>
				}
				subtitle={
					<Typography scale="medium" weight="400" textColor="neutral_700">
						Se anularan las cuotas pendientes y se marcara como recuperado el
						credito
					</Typography>
				}
			/>
		</>
	);
}
export default RepossessionOzoner;
